// extracted by mini-css-extract-plugin
module.exports = {"header":"header--2lFdc","block":"block--3D4q3","block-title":"block-title--1RIs_","btn-line":"btn-line--2wV3r","full":"full--BFjPO"};